var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgText(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66667 14H18.3333C19.25 14 20 14.6751 20 15.5002C20 16.3253 19.25 17.0004 18.3333 17.0004H1.66667C0.75 17.0004 0 16.3253 0 15.5002C0 14.6751 0.75 14 1.66667 14Z",
    fill: "#33385C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.67798 1.27506C4.67798 1.98059 5.2475 2.55011 5.95303 2.55011H8.92816V10.7249C8.92816 11.4305 9.49769 12 10.2032 12C10.9087 12 11.4783 11.4305 11.4783 10.7249V2.55011H14.4534C15.1589 2.55011 15.7285 1.98059 15.7285 1.27506C15.7285 0.569525 15.1589 0 14.4534 0H5.95303C5.2475 0 4.67798 0.569525 4.67798 1.27506Z",
    fill: "#33385C"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgText);
export default __webpack_public_path__ + "static/media/text.9cb21f4f.svg";
export { ForwardRef as ReactComponent };